<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Predelovalec</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
<div v-if="!predelovalecid">
    NI PODATKOV
</div>
<div v-else>
<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
                <predelovalec :predelovalec="predelovalec">
          </predelovalec>
            
          </div>
        </div>
 <div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button class="k-button k-primary" :disabled="predelovalec.pisanje==0" @click="saveData" >Shrani</button>
                <button class="k-button k-primary" @click="nazajPredelava" >Nazaj</button>
               </div>
             </div>

    <div class="tb-col-lg-2 tb-col-sm-3 pt-1">
    <div>
            <fieldset class="left-border-for-children">
                 <div class="form-fieldset-header">
            <h2 >Podatki o predelovalcu</h2>
        </div>

            </label>
              <label for="jeaktivna" class="k-form-field k-checkbox-field">
                <span>Je v kontroli (aktivna)</span>
            <input type="checkbox" :disabled="predelovalec.pisanje==0" v-model="jeaktivna"  name="jeaktivna" id="jeaktivna" class="k-checkbox" />
        </label>

             <label for="kntst" class="k-form-field">
                <span>Kontrolna številka</span>
                
                <input type="text" :disabled="predelovalec.pisanje==0" v-model="predelovalec.kontrolnastevilka" placeholder="Kontrolna številka" name="kntst" id="kntst" class="k-textbox" />
                 
            </label>
          
<div class="display-flex">
            <label for="status" class="k-form-field flex-grow-1">
                <span>Status</span>
                 <dropdownlist
                @change="spremeniStatus"
                 name="status"
                :data-items="status"
                :text-field="'naziv'"
                :value="izbranStatus"
                :disabled="predelovalec.pisanje==0"
                
            />
            </label>

            <label for="statusDolocen" class="k-form-field">
                <span>Datum določitve statusa</span>
               <kendo-datepicker :disabled="predelovalec.pisanje==0" id="statusDolocen"
                       :value="statusDolocen"
                       @change="zamenjajDatum"
                      :format="'dd.MM.yyyy'"></kendo-datepicker>
            </label>
        </div>


        
        <div class="k-form-field">
                                <span>Vrsta predelovalca</span>
                                <kendo-multiselect :value="predelovalec.vrstapridelovalca"
                                :data-items="vrsta"
                                :text-field="'naziv'"
                                :data-item-key="'id'"
                                :placeholder="'Izberi vrsto'"
                                id="vrstapridelovalca"
                                @change="spremeniVrsto"
                                :messages="multiselectmessages"
                                :disabled="predelovalec.pisanje==0"
                                :filterable="true"
                                :auto-width="true"
                                >
                                </kendo-multiselect>
                            </div>
      
            </fieldset>
            <fieldset class="left-border-for-children">
                            <div class="form-fieldset-header">
                                <h2 >Certificirane kategorije</h2>
                            </div>
                
                            <div class="kat_chk_list">
                                <template v-for="kategorija in kategorije">
                                    <div :class="{'izbranakategorija':izbranekategorije.find(i=>(i.id?i.id:i)==kategorija.id)}">
                                        <input class="form-check-input" v-model="kategorijepredelovalca"  type="checkbox" :value="kategorija.id" :id="'kat_chk_'+kategorija.id">
                                        <label class="form-check-label" :for="'kat_chk_'+kategorija.id" >
                                            ({{kategorija.id}}) {{kategorija.naziv}}
                                        </label>
                                        <dropdownlist style="{ width: '60px';display: 'inline-block';}" :data-items='vrstapridelave' :text-field="'naziv'" :default-value='{id:"EK-P",naziv:"Ekološko razen v obdobju preusmeritve"}'
                                        v-model="statuskategorije[kategorija.id]"  @change="handlestatuskategorijechange(kategorija.id,$event)" >
                                        </dropdownlist>
                                    </div>
                                </template>
                            </div>

                        </fieldset>
             </div>
             
               
           </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideIntlService } from '@progress/kendo-vue-intl';
import PredelovalecKratko from './support/PredelovalecKratko';
export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
      'predelovalec':PredelovalecKratko
  },
    props:['sezona','predelovalecid'],
    data () {
        return {
                  dataSezona:this.sezona,
                   sezone:[],

            vrstapredelovalca:[],naziv:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
           
          
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrsta:[],
            status:[],
            kategorije:[],
             statuskategorije:[],
               vrstapridelave:[{id:"EK+K",naziv:"Ekološko z neekološko"},{id:"EK-P",naziv:"Ekološko razen v obdobju preusmeritve"},{id:"P",naziv:"Preusmeritev"}],
        }
    },
    computed: {
      izbranekategorije:
        {
           get() {

            let pridelava=null;

            if (this.predelovalec?.vnesenekategorije)
                return this.predelovalec?.vnesenekategorije;
            else
                return [];

          },
         
        },
        
        kategorijepredelovalca:
        {
           get() {

            

            if (this.predelovalec?.izbranekategorije)
                return this.predelovalec.izbranekategorije.map(i=>i.id);
            else
                return [];

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
            //pridelava.kontrolnaStevilka=value;
            console.log("UPDATE CHKBOX");
            console.log(value);
            console.log()
            this.updateprop({property:"izbranekategorije",value:value.map(i=>{return {id:i,status:(this.statuskategorije[i]?.id)?(this.statuskategorije[i]?.id):"EK-P"}})});
            //this.updateshemaprop({property:"kategorije",value:value.map(i=>{return {id:i,status:this.statuskategorije  [i]}})});
          }
        },
         jeaktivna:
        {
           get() {

            return this.predelovalec.jeaktivna>0?true:false;
          },
          set(value) {
            this.updateprop({property:"jeaktivna",value:value?1:0});

          }
        },
       
        izbranStatus:
        {
           get() {

            return this.status.find(i=>i.id==this.predelovalec.statuspredelovalcaid);
          },
          set(value) {
           this.updateprop({property:"statuspredelovalcaid",value:value.id});

          }
        },
         izbranaVrsta:
        {
           get() {
            
            return this.vrsta.find(i=>i.id==this.predelovalec.vrstapredelovalcaid);
          },
          set(value) {
           this.updateprop({property:"vrstapredelovalcaid",value:value.id});

          }
        },
        statusDolocen:
        {
           get() {
         
            return this.predelovalec.datumdolocitvestatusa?provideIntlService(this).parseDate(this.predelovalec.datumdolocitvestatusa):new Date();
          },
          set(value) {
       
          
          this.updateprop({property:"datumdolocitvestatusa",value:value.toISOString()});
          }
        },
        ...mapState('users', ['sezonePisanje']),
        ...mapState('predelava', ['predelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone'])
        
    },
    created () {
      this.dataSezona={sezona:this.sezona};
       this.naloziPodatke();
     
    },
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('predelava',['loadOne','save','loadIdPoSezoni']),
         ...mapMutations('predelava',['updateprop']),

         handlestatuskategorijechange (id,event)  {
             
             //this.kategorijepridelovalca=this.kategorijepridelovalca.map(i=>{return {id:i,status:event.target.value [i]}});
             console.log("handlestatuskategorijechange");
             console.log(id);
             console.log(event.value);
             this.statuskategorije[id]=event.value;
             console.log(this.statuskategorije);
             this.updateprop({property:"izbranekategorije",value:
                 this.predelovalec.izbranekategorije.map(i=>{return {id:i.id,status:(this.statuskategorije[i.id]?.id)?(this.statuskategorije[i.id]?.id):"EK-P"}})});
             console.log(this.predelovalec.izbranekategorije);
             //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema=="EKO PRI");
             /*var k=pridelava.kategorije.map(i=>{
                 if (i.id==id)
                     return {...i,status:event.value};
                 return i;   
             });
             console.log(k);
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:"EKO PRI",property:"kategorije",value:k});
             */
 
 
         },
 
        saveData(e){
          this.save( this.dataSezona);
        },
          handleSubmit(e){

          e.preventDefault();
        },
         cancel(e){
              this.$router.go(-1)
        },
        spremeniVrsto (event)  {
            this.izbranaVrsta=event.target.value;
             //this.updateprop({property:"vrstapredelovalca",value:[...event.target.value]});
            
        },
         spremeniStatus (event)  {
              this.izbranStatus=event.target.value;
            
        },
        zamenjajDatum(e){
            console.log(e);
            this.statusDolocen=e.value;
        },
       
        naloziPodatke (){
            // this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspredelovalca"]
  //       this.sifrant["vrstapredelovalca"]
         var thisComp=this;
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapredelovalca"}).then(()=>{
            thisComp.vrsta=thisComp.sifrant["vrstapredelovalca"];
        });
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"statuspredelovalca"}).then(()=>{
            thisComp.status=thisComp.sifrant["statuspredelovalca"];
        });
        this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"certifikatkategorija"}).then(()=>{
            thisComp.kategorije=thisComp.sifrant["certifikatkategorija"];
        });
        this.loadOne({sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid})
      
        },
         sezonaChange(event) {
             const sezona = event.value;
         if(this.dataSezona.sezona==sezona.sezona){
                console.log("Ista sezona, do nothing!!!");
                  return;  
          }

            this.loadIdPoSezoni({sezona:sezona.sezona,subjid:this.predelovalec.subjid}).then(predelovalec=>{
               this.dataSezona=sezona;
              console.log("sem tukaj noter!!!");
              this.predelovalecid=predelovalec.id;
             this.$router.push({ name: 'predelovalec', params: {sezona:sezona.sezona,predelovalecid:predelovalec.id} });
             this.naloziPodatke();
              });


          //  this.naloziPodatke();



        },
    }
};
</script>

<style>

.k-checkbox-field {
    display: flex !important;
    align-items: center;
}


.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}
</style>